// extracted by mini-css-extract-plugin
export var fadeIn = "_cg-1";
export var modalContent = "_cg-3";
export var overlay = "_cg-0";
export var popoverContent = "_cg-2";
export var results = "_cg-5";
export var searchInputWrapper = "_cg-4";